import zippedLower from "../../../assests/HPE/enterpriseone/ent-a/folder-sm-fg.png";
import document1 from "../../../assests/HPE/enterpriseone/ent-a/webp/zip-documents-1.webp";
import document2 from "../../../assests/HPE/enterpriseone/ent-a/webp/zip-documents-2.webp";
import document3 from "../../../assests/HPE/enterpriseone/ent-a/webp/zip-documents-3.webp";

const StackedDocuments = () => {
  return (
    <div className="relative w-full max-w-[360px] md:max-w-[456px] h-[160px] -mt-12 md:mt-0 font-inter">
      <svg
        className="absolute mt-6 md:mt-0 inset-0 w-full h-full z-[1]"
        viewBox="0 0 456 132"
      >
        <path
          d="M0 12V120C0 126.627 5.37259 132 12 132H444C450.627 132 456 126.627 456 120V41C456 34.3726 450.627 29 444 29H99.304C96.4959 29 94.0635 27.0524 93.4493 24.3123L90.1014 9.37546C88.8731 3.89525 84.0081 0 78.3919 0H12C5.37258 0 0 5.37257 0 12Z"
          fill="#2A2D55"
        />
      </svg>

      <div className="absolute top-[60px] md:top-6 left-2 lg:left-3 z-[5] text-grey-01 text-[10px] md:text-[12px] font-medium">
        Zip · 5.23MB
      </div>

      <div className="absolute top-[56px] md:top-4  right-4 z-[5] text-white text-[10px] md:text-[12px] font-medium">
        What’s inside?
      </div>
      <div className="absolute inset-0 flex items-end justify-center z-[3] overflow-hidden">
        {/* LEFT IMAGE */}
        <img
          src={document1}
          alt=""
          className="
            absolute
            left-[10%] md:left-[60px]
            bottom-[-35px] md:bottom-[-40px]
            w-[90px] h-[110px] md:w-[110.772px] md:h-[130.193px]
            rotate-[4deg]
            object-cover
            rounded-md
            shadow-[0_0_5.754px_rgba(0,0,0,0.25)]
            z-[2]
          "
        />

        {/* CENTER IMAGE */}
        <div
          className="
            absolute
            bottom-[-25px] md:bottom-[-30px]
            w-[95px] h-[120px] md:w-[110.772px] md:h-[143.14px]
            rounded-md
            shadow-[0_0_5.754px_rgba(0,0,0,0.25)]
            z-[4]
          "
          style={{
            backgroundImage: `url(${document2}), url(${document2})`,
            backgroundPosition: "0px -0.034px, -0.092px -0.098px",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        />

        {/* RIGHT IMAGE */}
        <div
          className="
            absolute
            right-[10%] md:right-[60px]
            bottom-[-35px] md:bottom-[-40px]
            w-[90px] h-[110px] md:w-[110.772px] md:h-[130.193px]
            -rotate-[4deg]
            rounded-md
            shadow-[0_0_5.754px_rgba(0,0,0,0.25)]
            z-[2]
            object-cover
          "
          style={{
            background: `url(${document3}) lightgray -0.1px -0.094px / 100.083% 100.072% no-repeat`,
          }}
        />
      </div>

      <img
        src={zippedLower}
        alt=""
        className="absolute md:bottom-0 -bottom-1 left-0 w-full z-[5]"
      />

      {/* ===== BOTTOM TEXT BAR ===== */}
      <div className="absolute bottom-[-3px] left-0 right-4 md:bottom-1 md:right-4 z-[6] flex items-center gap-2 w-full  px-3 py-1.5 rounded-lg">
        <div className="flex items-center justify-center px-2 py-[2px] rounded-full ">
          <span className="text-white text-[8px] md:text-[10px] font-medium leading-none bg-pdf py-1 px-2 gap-2.5 md:py-1 md:px-2 md:gap-2.5 justify-center items-center rounded-[24px]">
            PDF
          </span>
        </div>

        <p className="text-grey-01 text-[10px] md:text-[12px] font-medium leading-none truncate">
          GigaOm Radar, AstraZeneca Customer Story, IDC Spotlight
        </p>
      </div>
    </div>
  );
};

export default StackedDocuments;
